import {
  CustomerModuleList,
  CustomerModulesApi,
  CustomerModuleView,
  FeatureFlag,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const list = async (): Promise<CustomerModuleList> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomerModulesApi)
  return await api.listCustomerModules({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  })
}

const setModule = async (
  moduleId: string,
  enabled: boolean,
  features: FeatureFlag[],
): Promise<CustomerModuleView> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomerModulesApi)
  return await api.setCustomerModule({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    moduleId,
    setCustomerModuleBody: { enabled, features },
  })
}

export const CustomerModulesServiceAPI = {
  list,
  setModule,
}
